var _polyline, _polyline2, _polyline3, _polyline4, _polyline5, _polyline6, _line, _polyline7, _polyline8, _line2, _line3, _polyline9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2129.6201 1961.25",
    fill: "none",
    stroke: "currentColor",
    width: 2129.6201,
    height: 1961.25,
    strokeWidth: 25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "770.16,1527.82 265.05,1022.72 180.87,1106.9 685.98,1612.01"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "1527.82,1780.38 1106.9,1359.45 938.53,1527.82 1359.45,1948.75"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    points: "1864.56,265.05 1527.82,601.79 2117.12,1191.09"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    points: "433.42,349.24 854.35,770.16 601.79,1022.72 854.35,1275.27"
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    points: "938.53,854.35 1022.72,938.53 854.35,1106.9 1022.72,1275.27 854.35,1443.64 265.05,854.35"
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    points: "265.05,349.24 601.79,685.98 433.42,854.35 265.05,685.98 12.5,938.53"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y2: 685.97998,
    x2: 1275.27,
    y1: 349.23999,
    x1: 1612.01
  })), _polyline7 || (_polyline7 = /*#__PURE__*/React.createElement("polyline", {
    points: "1527.82,265.05 1106.9,685.98 938.53,517.61 854.35,601.79 1191.09,938.53 1443.64,685.98 2032.93,1275.27"
  })), _polyline8 || (_polyline8 = /*#__PURE__*/React.createElement("polyline", {
    points: "601.79,180.87 854.35,433.42 938.53,349.24 1106.9,517.61 1443.64,180.87"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y2: 349.23999,
    x2: 1106.9,
    y1: 12.5,
    x1: 770.15997
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y2: 1359.45,
    x2: 1948.75,
    y1: 938.53003,
    x1: 1527.8199
  })), _polyline9 || (_polyline9 = /*#__PURE__*/React.createElement("polyline", {
    points: "1864.56,1443.64 1359.45,938.53 1106.9,1191.09 1275.27,1359.45 1359.45,1275.27 1443.64,1191.09 1780.38,1527.82"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.d7ae17e8f6a7f470fd8c0ee8901fc278.svg";
export { ForwardRef as ReactComponent };